import * as types from '../types/restaurant';

export default function Restaurant(state = {
  list: [],
  selectedId: null,
  startFetch: false,
  item: {},
}, action) {
  switch (action.type) {
    case types.RESTAURANT_FETCHED:
      return {
        ...state,
        list: action.data.map((item, index) => {
          return item;
        }),
      };
    case types.RESTAURANT_SELECTED:
      return {
        ...state,
        item: action.data,
        selectedId: action.data.id,
      };
    case types.RESTAURANT_UPDATED_ORDER_TIME:
      return {
        ...state,
        item: {
          ...state.item,
          ...action.data,
        },
      };
    case types.RESTAURANT_SELECTED_WITHOUT_FETCH:
      return {
        ...state,
        selectedId: action.data,
      };
    case types.RESTAURANT_START_FETCH:
      return {
        ...state,
        startFetch: true,
      };
    case types.RESTAURANT_END_FETCH:
      return {
        ...state,
        startFetch: false,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurant.js